"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reverifyEmailResult = void 0;
var react_redux_1 = require("react-redux");
var React = require("react");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var mapStateToProps = function (state) {
    return state.reverifyEmailResult;
};
var mapDispatchToProps = function () { return ({}); };
exports.reverifyEmailResult = function (props) {
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { id: "reverify-email-result-page", className: "g-reset l-container l-container--r75 l-container--stackable l-pad-top--3" },
            React.createElement("div", { className: "l-container__main" },
                React.createElement("div", { className: "c-page-header c-page-header--center" },
                    React.createElement("div", { className: "c-page-header__body" },
                        React.createElement("div", { className: "c-page-header__title" }, props.t.nameReverifyEmailTitle),
                        React.createElement("div", { className: "c-page-header__caption" }, props.t.nameReverifyEmailCaption))),
                React.createElement("div", { className: "c-jumbo c-jumbo--lift" },
                    React.createElement("div", { className: "c-jumbo__header" },
                        React.createElement("div", { className: "c-jumbo__header-main" },
                            React.createElement("div", { className: "c-jumbo__title" }, props.t.submitSuccess),
                            React.createElement("div", { className: "c-jumbo__caption" }, props.t.submitSuccessCaption)),
                        React.createElement("div", { className: "c-jumbo__header-side" },
                            React.createElement("div", { className: "c-jumbo__logo c-jumbo__logo--success" },
                                React.createElement("i", { className: "fa fa-check" })))),
                    React.createElement("div", { className: "c-jumbo__body" },
                        React.createElement("div", { className: "c-jumbo__content" },
                            React.createElement("div", { className: "c-jumbo__content-row" },
                                props.t.instructionSentTo,
                                React.createElement("span", { className: "o-consolas" }, props.email)),
                            React.createElement("div", { className: "c-jumbo__content-row" }, props.t.clickToContinue)),
                        React.createElement("div", { className: "c-jumbo__actions" },
                            React.createElement("a", { id: "reverify-email-result-mailbox-button", target: "_blank", href: props.mailBoxUrl, className: "o-btn o-btn--primary" },
                                props.t.goto,
                                " ",
                                props.mailBoxName,
                                " ",
                                props.t.mailBox))),
                    React.createElement("div", { className: "c-jumbo__bg" },
                        React.createElement("i", { className: "fa fa-envelope" })))),
            React.createElement("div", { className: "l-container__side c-side c-side--for-items" },
                React.createElement("div", { className: "c-side__item" },
                    React.createElement("div", { className: "c-side__body c-side__body--padleft" },
                        React.createElement("div", { className: "c-side__title" }, props.t.needSupportTitle),
                        React.createElement("div", { className: "c-side__caption" },
                            React.createElement("div", { className: "c-labelrow" },
                                React.createElement("div", { className: "c-labelrow__label" },
                                    React.createElement("i", { className: "fa fa-envelope" })),
                                React.createElement("div", { className: "c-labelrow__value" },
                                    React.createElement("a", { href: "" },
                                        " ",
                                        props.t.needSupportEmail,
                                        " "))),
                            React.createElement("div", { className: "c-labelrow" },
                                React.createElement("div", { className: "c-labelrow__label" },
                                    React.createElement("i", { className: "fa fa-phone" })),
                                React.createElement("div", { className: "c-labelrow__value" }, props.t.needSupportPhone)))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.reverifyEmailResult);
